import React from 'react';
import { Grid } from '@amzn/awsui-components-react';
import { Box } from '@amzn/awsui-components-react';
import awslogo from '../img/awslogo.png';

class Header extends React.Component {
  render() {
    return (
      <div className="header">
        <div className="awsui-util-container max-width-container awsui-util-no-gutters">
          {/* POLARIS_V3.0_MIGRATION_WARNING: This grid implementation was automatically migrated. Make sure that it continues to work as expected */}
          <Grid
            gridDefinition={[{ colspan: { xxs: 2 } }, { colspan: { xxs: 8 } }]}
          >
            {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
            {/* POLARIS_V3.0_MIGRATION_WARNING: Add color="inherit" if this element is within the `empty` or `noMatches` regions of Table or Cards components. */}
            <Box textAlign="center" margin={{ top: 'xs' }} className="logo">
              <a href="/">
                <img src={awslogo} alt="AWS logo" />
              </a>
            </Box>

            {/* POLARIS_V3.0_MIGRATION_WARNING: Replace this Box component with the Header component if the heading is in the Header of a Form, Table, Container or FormSection. */}
            {/* POLARIS_V3.0_MIGRATION_WARNING: Add color="inherit" if this element is within the `empty` or `noMatches` regions of Table or Cards components. */}
            <div style={{ color: 'white' }}>
              <Box
                variant="h1"
                textAlign="center"
                fontSize="heading-xl"
                color="inherit"
              >
                AWS Client VPN Self-Service Portal
              </Box>
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}

export default Header;
